import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#5575DF',      // Y2D blue
        secondary: '#19BFA7',    // Y2D teal
        accent: '#FF7D6A',       // Y2D coral
        // Colores semánticos: DISTINTOS de la marca para que el color signifique algo
        info: '#5575DF',
        success: '#16A34A',      // verde propio (antes = secondary teal)
        warning: '#F5A623',
        error: '#E5484D',        // rojo real (antes = accent coral)
        anchor: '#5575DF',
        background: '#FAFAFB',
      }
    }
  }
})
